<script setup lang="ts">
    import VisibilityToggle from '@/views/3d-planner/components/VisibilityToggle.vue';
    import { usePlannerSceneViewModel } from '@/views/3d-planner/store/plannerSceneViewModel';
    import { computed } from 'vue';
    import { any } from '@/util/array';
    import type { VisibilityToggleId } from '@/views/3d-planner/measurements/visibilityToggles';
    import { PLANNER_TARGETS } from '@/domain/analytics/analyticsTargets';

    const scene = usePlannerSceneViewModel();

    const anyCrossSectionShown = computed<boolean>(() =>
        any<VisibilityToggleId>(
            (id) => scene.visibility[id] !== 'hidden',
            ['stem-neck-cross-section', 'stem-coronal-cross-section', 'cup-coronal-cross-section'],
        ),
    );
</script>

<template>
    <div class="app-planner-view-modes">
        <visibility-toggle id="femur" />
        <visibility-toggle id="pelvis" />
        <visibility-toggle id="implant" />
        <visibility-toggle id="xray" />
        <div v-if="anyCrossSectionShown" class="app-planner-view-mode-divider" />
        <visibility-toggle
            id="stem-neck-cross-section"
            :data-analytics-id="PLANNER_TARGETS.neckCrossSectionButton"
        />
        <visibility-toggle
            id="stem-coronal-cross-section"
            :data-analytics-id="PLANNER_TARGETS.stemCrossSectionButton"
        />
        <visibility-toggle id="cup-coronal-cross-section" />
    </div>
</template>

<style scoped lang="scss">
    .app-planner-view-modes {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .app-planner-view-mode-divider {
        border-right: 1px solid rgb(var(--v-theme-outline));
        margin: 0 10px;
        height: 28px;
    }
</style>
